export default "__VITE_ASSET__2n1JL3Xj__"